import React from 'react'
import { Image, Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer'
import dayjs from 'dayjs'
import { CustomerAddress, DocumentDate, Footer, Header, style } from '../../document/DocumentPDF'

const AttestationPDF = ({
  intervention_param: intervention,
  company_param: company,
  logo_param: img,
  user_param: user,
  cachet_param: cachet
}) => {
  const customer = intervention.customer
  const styles = StyleSheet.create(style)
  const firstCharCachet = cachet.charAt(0)
  const extensionCachet = {
    '/': 'jpeg',
    i: 'png',
    R: 'gif',
    U: 'webp'
  }[firstCharCachet]

  const References = () => {
    if (intervention) {
      return (
        <>
          <View style={styles.rightContainer}>
            <Text style={styles.boldWithSpace}>Référence intervention</Text>
            <Text style={styles.address}>{intervention.intervention_number}</Text>
          </View>
        </>
      )
    }
  }

  const InterventionSubject = () => (
    <View>
      <View style={{ marginTop: 20 }}>
        <Text style={styles.bold}>Attestation prise en charge matériel</Text>
      </View>
      <View style={{ marginTop: 20 }}>
        <Text style={styles.address}>
          Je soussigné {user.firstname} {user.lastname} représentant légal de la société {company.name} dont le siège
          social est basé {company.address1} {company.address2} {company.zip} {company.city}
        </Text>
        <Text style={styles.address}>atteste sur l'honneur avoir pris en charge le matériel suivant :</Text>
        <Text style={styles.address}>{intervention.material} </Text>
        <Text style={styles.address}>appartenant à {customer.customer_name}</Text>
        <Text style={styles.address}>
          dans le cadre de l'intervention {intervention.intervention_number} à la date du{' '}
          {dayjs(intervention.intervention_date).format('DD/MM/YYYY')}.
        </Text>
        <Text style={styles.address}>
          Ce matériel lui sera restitué lors de l'achèvement de l'intervention pour laquelle la société {company.name} a
          été mendaté par {customer.customer_name}
        </Text>
        <Text style={styles.address}>Fait pour service et valoir ce que de droit.</Text>
      </View>
      <View style={{ marginTop: 20 }}>
        {cachet !== undefined && cachet !== null && cachet !== '' ? (
          <Image style={styles.logo} src={`data:image/${extensionCachet};base64,${cachet}`} />
        ) : (
          <View style={styles.logo} />
        )}
      </View>
    </View>
  )

  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <View fixed>
          <Header styles={styles} title={'PRISE EN CHARGE MATERIEL'} img={img} titleSize={'small'} />
          <References />
          <DocumentDate date={intervention.intervention_date} styles={styles} />
        </View>
        <View>
          <CustomerAddress styles={styles} company={company} customer={customer} />
          <InterventionSubject />
        </View>
        <Footer company={company} styles={styles} />
      </Page>
    </Document>
  )
}

export default React.memo(AttestationPDF)
